export default __webpack_public_path__ + "static/media/fractal.859e9185.svg";